import React, { Component, Fragment } from 'react';
import withTranslations from '../../translations';
import { withStyles } from '@material-ui/core/styles';
import { withWidth } from '@material-ui/core';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { jobTypes } from '../../constants/job';

import { setOffset } from '../../actions/jobs';

import {
  getJobTableColumns,
  smallScreens,
} from './Job/constants';

import {
  isFilterOff
} from './../../utils/utils';

import {
  Button,
  Loader,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '../base';

import Job from './Job/Job';
import TopFilters from './TopFilters/TopFilters';
import FilterListIcon from '@material-ui/icons/FilterList';

const styles = theme => ({
  root: {
    padding: theme.spacing(2),
    overflowX: 'hidden',

    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(4),
    },
  },
  header: {
    display: 'flex',
    flexDirection: 'column-reverse',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: theme.spacing(4),

    [theme.breakpoints.up('lg')]: {
      justifyContent: 'center',
      flexDirection: 'row',
      alignItems: 'center',
    }
  },
  filter: {
    padding: theme.spacing(2),
  },
  filterIcon: {
    marginLeft: theme.spacing(2),
  },
  myJobs: {
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(2),
  },
  jobTable: {
    paddingRight: '0 !important',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(4),

    '& th': {
      padding: theme.spacing(1),
      margin: 0,
    },
    '& td': {
      padding: theme.spacing(1),
    },
  },
  tableHeaderRow: {
    height: 36,
    borderBottom: `1px solid ${theme.palette.text.primary}`,

    [theme.breakpoints.up('sm')]: {
      background: theme.palette.grey[300],
    },
  },
  tableHeaderRowAlert: {
    height: 36,
    background: theme.palette.error.light,
  },
  tableHeaderText: {
    textTransform: 'uppercase',
    textAlign: 'left',
    color: theme.palette.text.primary,
  },
  loaderContainer: {
    textAlign: 'center'
  },
  tag: {
    width: 32,
  },
  id: {
    width: 50,
  },
  createdAt: {
    width: 90,
  },
  receivedDate: {
    width: 90,
  },
  customer: {
    minWidth: 100,
    maxWidth: '100%',
  },
  customerName: {
    minWidth: 100,
    maxWidth: '100%',
  },
  serialProductNumber: {
    minWidth: 90,
    maxWidth: 180,
  },
  materialNumber: {
    minWidth: 90,
    maxWidth: 180,
  },
  materialDescription: {
    minWidth: 100,
    maxWidth: 200,
  },
  equipmentSerialNumber: {
    minWidth: 160,
    maxWidth: 320,
  },
  customerCenterPlantCode: {
    width: 60,
  },
  serviceTechnologyCenterPlannerGroup: {
    width: 60,
  },
  handledBy: {
    minWidth: 100,
    maxWidth: '100%',
  },
  reportLevel: {
    width: 60,
  },
  unreadMessages: {
    width: 40,
  },
  expand: {
    width: 32,
  },
  edit: {
    width: 32,
  },
});

const renderTableColumns = (columnsArray, c, hasAlert) =>
  columnsArray.map(column =>
    <TableCell className={c[column.colName]} key={column.colId}>
      <Typography className={classNames(c.tableHeaderText, c.textColor)} variant='caption'>
        {column.text}
      </Typography>
      <Typography variant="srOnly">{column.label}</Typography>
    </TableCell>
  );

class Jobs extends Component {
  limit = 10;

  // If BE returns no jobs, and offset is GTE limit, try to fetch jobs with smaller offset.
  async componentDidUpdate(prevProps, prevState) {
    const { myJobsOffset, otherJobsOffset } = this.props.offsets;
    const { myJobs, otherJobs } = this.props;
    
    if (otherJobs && otherJobs.length === 0 && otherJobsOffset >= this.limit) {
      const newOffset = otherJobsOffset - this.limit;
      await this.handlePagination(jobTypes.other, newOffset, 'no') && this.handlePagination(jobTypes.my, myJobsOffset, 'no');
    }

    if (myJobs && myJobs.length === 0 && myJobsOffset >= this.limit) {
      const newOffset = myJobsOffset - this.limit;
      await this.handlePagination(jobTypes.my, newOffset) && this.handlePagination(jobTypes.other, otherJobsOffset, 'no');
    }

  }

  renderJobs = jobs => jobs.map(job =>
    <Job
      key={job.id}
      data={job}
      handleTagJob={this.props.handleTagJob}
    />
  )

  sortJobs = (jobs, sort = 'DESC') =>
    sort === 'DESC'
      ? jobs.sort((a, b) => new Date(b.jobDate) - new Date(a.jobDate))
      : jobs.sort((a, b) => new Date(a.jobDate) - new Date(b.jobDate))

  // We're waiting onPaginationClick to finish so we can properly display Loader
  handlePagination = async (jobsGroup, offset, packData) => {
    await this.props.actions.setOffset(`${jobsGroup}Offset`, offset) && this.props.onPaginationClick(jobsGroup, offset, packData);
    return true;
  }

  render() {
    const { t, classes: c, myJobs, otherJobs, sorting, totalMyJobs, totalOtherJobs, handleFiltersClick, width, user } = this.props;
    const { myJobsOffset, otherJobsOffset } = this.props.offsets;
    const isSmallScreen = smallScreens.includes(width);
    const columns = getJobTableColumns(t, user);

    return (
      <div className={c.root}>
        <header className={c.header}>
          <TopFilters/>
            <Button
              className={c.filter}
              color="secondary"
              variant="outlined"
              onClick={handleFiltersClick}
            >
              {t.filters} <FilterListIcon className={c.filterIcon}/>
            </Button>
        </header>
        <Typography variant='h4'>{t.title}</Typography>
        <main className={c.myJobs}>
          <Typography variant='h6'>{t.myJobs}</Typography>
          {
             myJobs
              ? myJobs.length
                ? isSmallScreen
                  ? <Fragment>
                      {this.renderJobs(this.sortJobs(myJobs, sorting))}
                      <Pagination
                        limit={this.limit}
                        offset={myJobsOffset}
                        total={totalMyJobs}
                        onClick={(e, offset) => this.handlePagination(jobTypes.my, offset)}
                      />
                    </Fragment>
                  : <Fragment>
                      <Paper>
                        <Table className={c.jobTable}>
                          <TableHead>
                            <TableRow className={c.tableHeaderRow}>
                              {renderTableColumns(columns, c)}
                            </TableRow>
                          </TableHead>
                          <TableBody className={c.tableBody} onClick={e => e.stopPropagation()}>
                            {this.renderJobs(this.sortJobs(myJobs, sorting))}
                          </TableBody>
                        </Table>
                      </Paper>
                      <Pagination
                        limit={this.limit}
                        offset={myJobsOffset}
                        total={totalMyJobs}
                        onClick={(e, offset) => this.handlePagination(jobTypes.my, offset)}
                      />
                    </Fragment>
                : <Typography>{t.noJobsToDisplay}</Typography>
              : <div className={c.loaderContainer}><Loader color='secondary'/></div>
            }

        </main>
        <aside>
          <Typography variant='h6'>{t.otherJobs}</Typography>
          {
            otherJobs
              ? otherJobs.length
                ? isSmallScreen
                  ? <Fragment>
                      {this.renderJobs(this.sortJobs(otherJobs, sorting))}
                      <Pagination
                        limit={this.limit}
                        offset={otherJobsOffset}
                        total={totalOtherJobs}
                        onClick={(e, offset) => this.handlePagination(jobTypes.other, offset)}
                      />
                    </Fragment>
                  : <Fragment>
                      <Paper>
                        <Table className={c.jobTable}>
                          <TableHead>
                            <TableRow className={c.tableHeaderRow}>
                              {renderTableColumns(columns, c)}
                            </TableRow>
                          </TableHead>
                          <TableBody className={c.tableBody}>
                            {this.renderJobs(this.sortJobs(otherJobs, sorting))}
                          </TableBody>
                        </Table>
                      </Paper>
                      <Pagination
                        limit={this.limit}
                        offset={otherJobsOffset}
                        total={totalOtherJobs}
                        onClick={(e, offset) => this.handlePagination(jobTypes.other, offset)}
                      />
                   </Fragment>
                : <Typography>{this.props.isFilterOff ? t.pleaseUseTheSearchBar : t.noJobsToDisplay}</Typography>
              : <div className={c.loaderContainer}><Loader color='secondary'/></div>
          }

        </aside>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  offsets: state.jobs.offsets,
  filter: state.jobs.filter,
  isFilterOff: isFilterOff(state.jobs.filter),
})

const mapDispatchToProps = dispatch => ({
  actions: {
    setOffset: bindActionCreators(setOffset, dispatch),
  }
});

export default withWidth()(withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(withTranslations(Jobs, 'Jobs'))));



// WEBPACK FOOTER //
// ./src/components/Jobs/Jobs.js